import { Modal } from "../ui/modal/Modal"
import { ModalError } from "../ui/modal/ModalError"
import { msg } from "../ui/modal/utils"

import { api } from "../../services/api"
import { getCookie } from "../../helpers/cookies"
import { useQuery } from "../../hooks/useQuery"
import { Trans, useTranslation } from "react-i18next"

export const ModalEliminarJuego = ({ show, game, setGames }) => {
  const deleteUser = useQuery()

  const handleDelete = async () => {
    const { url, opt } = await api.games.delete({
      token: getCookie("jwt"),
      game_id: game.id,
    })

    // ejecuto
    deleteUser.url.current = url
    deleteUser.opt.current = opt

    deleteUser.run({
      onOk: () => {
        setGames((currents) => currents.filter((g) => g.id !== game.id))
        show[1](false)
      },
    })
  }

  const { t } = useTranslation()

  const modalFooter = () => {
    return (
      <>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => show[1](false)}>
          {t(`ui.btns.cancel`)}
        </button>

        <button
          type="button"
          className="btn btn-danger"
          disabled={deleteUser.isPending}
          onClick={() => handleDelete()}>
          {deleteUser.isPending
            ? t(`ui.btns.deleting`) + "..."
            : t(`ui.btns.yes`)}
        </button>
      </>
    )
  }

  return (
    <>
      <Modal
        id="confirmar-accion"
        show={show}
        className="darkie"
        header={<center>{t(`ui.msgs.confirm_action`)}</center>}
        body={msg(
          <Trans
            i18nKey="modals.modal_delete_game.are_you_sure"
            values={{ game: game.id }}
            components={{ b: <strong /> }}
          />
        )}
        footer={modalFooter()}
      />

      {/* en caso de erro, muestro una modal */}
      {deleteUser.res && deleteUser.err && (
        <ModalError show={show} res={deleteUser.res} />
      )}
    </>
  )
}
